import { EvchargeConfigState, EvchargeTelemetryState } from "../models";
import { AHevChargerCANType, AHevCharger485Type, AHsts, EvChRT, EvChType, AHdeviceTypeEnum } from "../telemetry";

export type InteractiveSessions = InteractiveSession[];

export interface InteractiveSession {
  id: string;
  deep: number;
  isFinish: boolean;
  isStartToday?: boolean;
};

export const initializeSessions = (data: EvChRT[]): InteractiveSessions => {
  const sessions: InteractiveSessions = [];
  data.forEach((item) => {
    const id = item.TID;
    const isPresent = sessions.find((session) => session.id === id);
    if (!isPresent) {
      sessions.push({
        id,
        deep: 0,
        isFinish: false,
      });
    }
  });
  return sessions;
};

export const getEvchargeTelemetryStatus = (state?: EvchargeConfigState) => {
  switch (state) {
    case EvchargeConfigState.Charging:
      return EvchargeTelemetryState.Charging;
    case EvchargeConfigState.Faulted:
      return EvchargeTelemetryState.Error;
    case EvchargeConfigState.Available:
      return EvchargeTelemetryState.Idle;
    case EvchargeConfigState.Preparing:
      return EvchargeTelemetryState.Idle;
    case EvchargeConfigState.SuspendedEVSE:
      return EvchargeTelemetryState.Parking;
    case EvchargeConfigState.SuspendedEV:
      return EvchargeTelemetryState.Parking;
    case EvchargeConfigState.Finishing:
      return EvchargeTelemetryState.Parking;
    case EvchargeConfigState.Reserved:
      return EvchargeTelemetryState.Idle;
    case EvchargeConfigState.Unavailable:
      return EvchargeTelemetryState.Error;
    default:
    return EvchargeTelemetryState.Error;
  }
};


export const  mapAHevChargerCANTypeToEvChType = (input: AHevChargerCANType | AHevCharger485Type): Partial<EvChType>  => {

  const mapStatus = (sts: AHsts): EvchargeTelemetryState => {
    switch (sts) {
      case AHsts.IDLE:
        return EvchargeTelemetryState.Idle;
      case AHsts.CHARGING_NO_PWR:
      case AHsts.CHARGING:
        return EvchargeTelemetryState.Charging;
      case AHsts.FINISH:
      case AHsts.PARKING:
      case AHsts.PAUSED:
        return EvchargeTelemetryState.Parking;
      case AHsts.ERROR:
      case AHsts.FAULT:
        return EvchargeTelemetryState.Error;
      default:
        return EvchargeTelemetryState.Idle;
    }
  };

  return {
    sn: input.sn,
    active: input.connected ? 1 : 0,
    fwVer: input.swVer || '',
    inputGreenPower: 0,
    dModel:  input.deviceType === AHdeviceTypeEnum.evChargerCAN ? (input as AHevChargerCANType).type : '',
    status: input.connected ? mapStatus(input.sts) : EvchargeTelemetryState.Error,
    updatedAt: input.updatedAt,
    createdAt: input.createdAt,
  };
}

export const getAzzurroHubEvchargeStatus = (state: AHsts) => {
  switch (state) {
    case AHsts.IDLE:
      return EvchargeTelemetryState.Idle;
    case AHsts.CHARGING:
    case AHsts.CHARGING_NO_PWR:
      return EvchargeTelemetryState.Charging;
    case AHsts.FINISH:
    case AHsts.PARKING:
    case AHsts.PAUSED:
      return EvchargeTelemetryState.Parking;
    case AHsts.ERROR:
    case AHsts.FAULT:
      return EvchargeTelemetryState.Error;
    default:
      return EvchargeTelemetryState.Idle;
  }
};
